import Head from 'next/head'
import './minireset.css'
import 'swiper/css/swiper.css'
import { useEffect } from 'react'
// This default export is required in a new `pages/_app.js` file.
import '@babel/polyfill';
export default function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <meta
          name="facebook-domain-verification"
          content="5ykh7p8p74jwgdornu56sciifho3ol"
        />
      </Head>
      <Component {...pageProps} />
    </>
  )
}
